import { render, staticRenderFns } from "./BlockedList.vue?vue&type=template&id=ffef18a8&scoped=true"
import script from "./BlockedList.vue?vue&type=script&lang=js"
export * from "./BlockedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef18a8",
  null
  
)

export default component.exports